import { createFileRoute } from '@tanstack/react-router';
import { HistoryPage } from '../../foundry/HistoryPage.js';

/** `/foundry/history`: Import history (2.I-2 stage s2). */
export const Route = createFileRoute('/foundry/history')({
  component: HistoryRoute,
});

function HistoryRoute(): React.JSX.Element {
  const { me } = Route.useRouteContext();
  return <HistoryPage me={me} />;
}
